


export type ProductSearchMode = 'Sale' | 'Purchase' | 'All' | 'WarehouseStock' | 'FabricationHoursBooking';

export const ProductSearchMode = {
    Sale: 'Sale' as ProductSearchMode,
    Purchase: 'Purchase' as ProductSearchMode,
    All: 'All' as ProductSearchMode,
    WarehouseStock: 'WarehouseStock' as ProductSearchMode,
    FabricationHoursBooking: 'FabricationHoursBooking' as ProductSearchMode
};

